import { wrapMutationForEntityDelete } from '@/queries/utils';
import {
  useRemoveHospitalContactMutationWithCorrelation,
  useRemoveOpoContactMutation,
  useRemoveCustomerMutationWithCorrelation,
  useRemoveHospitalMutation,
  useRemoveHubMutation,
  useRemoveOpoMutation,
  useRemoveTXCenterMutation,
} from './orchestrator.mutation';

export const useWrappedRemoveHospitalContactMutation = () => {
  const wrappedMutation = wrapMutationForEntityDelete(useRemoveHospitalContactMutationWithCorrelation);

  return wrappedMutation();
};

export const useWrappedRemoveOpoContactMutation = () => {
  const wrappedMutation = wrapMutationForEntityDelete(useRemoveOpoContactMutation);

  return wrappedMutation();
};

export const useWrappedRemoveTxCenterMutation = () => {
  const wrappedMutation = wrapMutationForEntityDelete(useRemoveTXCenterMutation);

  return wrappedMutation();
};

export const useWrappedRemoveCustomerMutation = () => {
  const wrappedMutation = wrapMutationForEntityDelete(useRemoveCustomerMutationWithCorrelation);

  return wrappedMutation();
};

export const useWrappedRemoveHospitalMutation = () => {
  const wrappedMutation = wrapMutationForEntityDelete(useRemoveHospitalMutation);

  return wrappedMutation();
};

export const useWrappedRemoveOpoMutation = () => {
  const wrappedMutation = wrapMutationForEntityDelete(useRemoveOpoMutation);

  return wrappedMutation();
};

export const useWrappedRemoveHubMutation = () => {
  const wrappedMutation = wrapMutationForEntityDelete(useRemoveHubMutation);

  return wrappedMutation();
};
